module.exports = __webpack_public_path__ + "static/media/accounting-icon.5bd56eb0.svg";